import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import "./CustomNavbar.css";
import { useEffect, useState } from "react";

const CustomNavbar = () => {
  const [navFixed, setNavFixed] = useState(false);
  const [windowSize, setWindowSize] = useState(undefined);

  const handleQuoteClick = () => {
    var elmntToView = document.getElementById("contact");
    elmntToView.scrollIntoView();
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) {
        setNavFixed(true);
      } else {
        setNavFixed(false);
      }
    });
  }, []);
  return (
    <>
      <Navbar expand="lg" className={`p-0 ${navFixed ? "fixed-navbar" : ""}`}>
        <Container fluid className="navbar_wrapper">
          <div className="logo">
            <Navbar.Brand href="#home" className="mainLogo">
              <img
                src={`assets/images/${navFixed ? "mobile_logo" : "Logo"}.png`}
                alt="orange_pattern"
                className="logo"
              />
            </Navbar.Brand>
            <Navbar.Brand href="#home" className="mobileLogo">
              <img
                src="assets/images/mobile_logo.png"
                alt="orange_pattern"
                className="logo"
              />
            </Navbar.Brand>
            <div className="navbar_contact_mob">
              <FontAwesomeIcon icon={faPhone} className="nav_phone_icon" />
              <a href="tel:5565454117">022 23808403</a>
            </div>
          </div>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <div className="navbar_left">
                <Nav.Link href="/#home">Home</Nav.Link>
                <Nav.Link href="/#about">About</Nav.Link>
                <Nav.Link href="/#branches">Branches</Nav.Link>
                <Nav.Link href="/#products">Products</Nav.Link>
                <Nav.Link href="/#contact">Contact us</Nav.Link>
              </div>
              <div className="navbar_right">
                <div className="navbar_button_container  d-flex">
                  <button className="quote_button" onClick={handleQuoteClick}>
                    Get a quote
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="nav_arrowRight"
                    />
                  </button>
                </div>
                <div className="navbar_contact d-flex align-items-center">
                  <FontAwesomeIcon icon={faPhone} className="nav_phone_icon" />
                  <a href="tel:022 23895360">022 23808403</a>
                </div>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default CustomNavbar;
